import type { FieldValidation } from '@rjsf/utils';
import { RepoData } from './types';

/**
 * Utility functions for CustomRepoUrlPicker
 */

/**
 * Validates project name according to our rules
 */
export const validateProjectName = (name: string): string => {
  if (!name) {
    return '';
  }
  if (name.length < 3) {
    return 'Nome deve ter pelo menos 3 caracteres';
  }
  if (name.length > 50) {
    return 'Nome deve ter no máximo 50 caracteres';
  }
  if (!/^[a-zA-Z0-9-]+$/.test(name)) {
    return 'Apenas letras, números e hífens são permitidos';
  }
  if (/^[-_]|[-_]$/.test(name)) {
    return 'Nome não pode começar ou terminar com hífen ou underscore';
  }
  if (/--+|__+/.test(name)) {
    return 'Hífens ou underscores consecutivos não são permitidos';
  }
  return '';
};

/**
 * Converts string to kebab-case format
 */
export const cleanStringToKebabCase = (str: string): string => {
  return str
    .toLowerCase()
    .replace(/[^a-z0-9-]/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
};

/**
 * Custom validation function for Scaffolder integration
 */
export const customRepoUrlPickerValidation = (
  value: RepoData,
  validation: FieldValidation,
) => {
  if (!value) {
    validation.addError('Configuração do repositório é obrigatória');
    return;
  }

  // Validate project name
  if (!value.projectName) {
    validation.addError('Nome do projeto é obrigatório');
  } else {
    const projectNameError = validateProjectName(value.projectName);
    if (projectNameError) {
      validation.addError(`Nome do projeto: ${projectNameError}`);
    }
  }

  // Validate required fields
  if (!value.projectType) {
    validation.addError('Tipo do projeto é obrigatório');
  }
  if (!value.namespace) {
    validation.addError('Localização do repositório é obrigatória');
  }
  if (!value.host) {
    validation.addError('Host do repositório é obrigatório');
  }
};
